import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDashboardContext } from '../../../components/providers/DashboardProvider';
import { useAuth } from '../../../components/providers/AuthProvider';
import BlockCard from './BlockCard';
import RawDataPanel from '../RawDataPanel';
import UnavailableCard from '../UnavailableCard';
import inverter_unavailable from '../../../assets/animations/unavailable/inverter.gif';

const PcsPage = () => {
  const { user } = useAuth();
  const isAdmin = user?.profile?.user_type === 'admin';

  const { pollingCounter } = useDashboardContext();

  const [init, setInit] = useState(true);

  const {
    fetchClusterPcsData, pcsData,
  } = useDashboardContext();

  const runRoutine = async () => {
    console.log("Polling in Pcs");
    fetchClusterPcsData();
  }

  useEffect(() => {
    if (init) {
      console.log("Initializing PCS page...");
      if (pcsData == null) {
        console.log("First poll...");
        runRoutine();
      }
      setInit(value => false);
    } else {
      if (pollingCounter != 0) {
        runRoutine();
      }
    }
  }, [pollingCounter]);

  const blocks = Object.entries(pcsData?.blocks_data || {});

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      width: "100%",
      pt: 2,
      gap: 2,
    }}>
      {blocks.map(([blockId, blockData]) => (
        <BlockCard
          key={blockId}
          id={blockId}
          data={blockData}
        />
      ))}

      {/* Data loaded but no PCS blocks configured */}
      {pcsData && blocks.length === 0 &&
        <UnavailableCard
          title="AC/DC data unavailable"
          message="Power conversion system data is not ready yet. Please contact your system administrator for more details."
          image={inverter_unavailable}
        />
      }

      {pcsData && isAdmin && <RawDataPanel data={pcsData} />}
    </Box>
  )
}

export default PcsPage
